
import React from 'react';
import { Helmet } from 'react-helmet-async';

const ResourcesHelmet = () => {
  return (
    <Helmet>
      <title>Medication Education - AutoPilot Care</title>
      <meta name="description" content="Educational resources and videos about medications and treatments." />
      <meta property="og:title" content="Medication Education - AutoPilot Care" />
      <meta property="og:description" content="Educational resources and videos about medications and treatments." />
      <meta property="og:image" content="/images/autopilot-og-image.png?v=6" />
      <meta property="og:updated_time" content="2024-04-11T00:00:00Z" />
      <meta property="og:url" content="https://autopilotcare.com/education?v=6" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      <link rel="preconnect" href="https://www.youtube.com" />
      <link rel="preconnect" href="https://www.youtube-nocookie.com" />
      <link rel="preconnect" href="https://platform.twitter.com" />
    </Helmet>
  );
};

export default ResourcesHelmet;

